import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { changelogs } from '@/lib/changelogs';

export default function ChangelogPage() {
  return (
    <div className="space-y-6 pb-8">
      <div className="flex items-center gap-3">
        <Link to="/">
          <Button variant="ghost" size="icon">
            <ArrowLeft className="h-5 w-5" />
          </Button>
        </Link>
        <h1 className="text-2xl font-bold">更新情報</h1>
      </div>

      <div className="space-y-3">
        {changelogs.map(log => (
          <Card key={log.version}>
            <CardContent className="flex items-start gap-3 p-4">
              <Sparkles className="h-4 w-4 text-primary mt-0.5 shrink-0" />
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-semibold">v{log.version}</span>
                  <span className="text-xs text-muted-foreground">{log.date}</span>
                </div>
                <p className="text-sm text-muted-foreground">{log.summary}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
